import Vue from 'vue'
import { rtdbPlugin } from 'vuefire'
import App from './App.vue'
import router from './router'
import store from './store/index'
import JwPagination from 'jw-vue-pagination'
import Tooltip from 'vue-directive-tooltip'

Vue.config.productionTip = false

Vue.component('jw-pagination', JwPagination)
Vue.use(Tooltip)

new Vue({
  rtdbPlugin,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
